import { SensorConfigurationByType, SubSensorConfigurationByType } from './configuration.types';
import { SensorTypeEnum, SubSensorTypeEnum } from './sensors';

type ExcludedTypes =
  | SensorTypeEnum.DRONE_SHIELD
  | SensorTypeEnum.ONVIF
  | SubSensorTypeEnum.ARDRONIS_ANTENNA
  | SubSensorTypeEnum.GENERIC_SUB_SENSOR
  | SubSensorTypeEnum.ROBIN_MAX_RADAR
  | SubSensorTypeEnum.SENID_ANTENNA
  | SubSensorTypeEnum.SPEXER_RADAR
  | SubSensorTypeEnum.SKY_EYE_ANTENNA
  | SubSensorTypeEnum.SKY_JACKER_ANTENNA;

export type SensorTypeWithShorthand = Exclude<SensorTypeEnum | SubSensorTypeEnum, ExcludedTypes>;

export type GetSensorOrSubSensorConfigurationWithShorthand<SensorType extends SensorTypeWithShorthand> =
  SensorType extends SubSensorTypeEnum
    ? SubSensorConfigurationByType<Extract<SensorType, SubSensorTypeEnum>>
    : SensorConfigurationByType<Extract<SensorType, SensorTypeEnum>>;
export type SensorOrSubSensorWithShorthand = GetSensorOrSubSensorConfigurationWithShorthand<SensorTypeWithShorthand>;

export const EXCLUDED_FROM_EDITION = [
  SubSensorTypeEnum.AUTOMATON_CABINET,
  SubSensorTypeEnum.AUTOMATON_SEGMENT,
] as const satisfies readonly SensorTypeWithShorthand[];
export type ExcludedFromEditionType = (typeof EXCLUDED_FROM_EDITION)[number];
export type EditableType = Exclude<SensorTypeWithShorthand, ExcludedFromEditionType>;

export type EditableSensorOrSubSensorWithShorthand = GetSensorOrSubSensorConfigurationWithShorthand<EditableType>;
